var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.missionsList
    ? _c(
        "div",
        {
          staticClass: "d-flex flex-column p-5 missions-wrapper",
          attrs: { id: "mission-list-wrapper" },
          on: { scroll: _vm.fetchMore }
        },
        [
          _vm.showCloseBtn
            ? _c(
                "div",
                {
                  staticClass: "stick-top-right",
                  staticStyle: { top: "10px", right: "16px" }
                },
                [
                  _c("button", {
                    staticClass: "btn-close md-close vs-btn-legacy",
                    attrs: { type: "button" },
                    on: { click: _vm.closeModal }
                  })
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("h2", { staticClass: "my-2" }, [_vm._v("\n    Missions\n  ")]),
          _vm._v(" "),
          _c("span", { staticClass: "mb-4" }, [
            _vm._v("Complete Missions & Claim Your Points Now to Level Up!")
          ]),
          _vm._v(" "),
          _vm._l(_vm.missionsList, function(mission, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass:
                  "d-flex justify-content-between align-items-center mb-4"
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "circular-progress-bar",
                    style: {
                      background:
                        "radial-gradient(closest-side, white 79%, transparent 80% 100%), conic-gradient(#E81A65 " +
                        _vm.missionProgress(mission) +
                        ", #d3d3d3 0%)"
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "d-flex flex-column justify-items-center"
                      },
                      [
                        _c("span", { staticClass: "mission-reward-amount" }, [
                          _vm._v(_vm._s(mission.rewards[0].amount))
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "mission-reward-type" }, [
                          _vm._v(_vm._s(mission.rewards[0].currencyType))
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("progress", {
                      staticStyle: {
                        visibility: "hidden",
                        height: "0",
                        width: "0"
                      },
                      attrs: { value: "75", min: "0", max: "100" }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "d-flex mx-5 flex-grow-1",
                    attrs: { id: "mission-content" }
                  },
                  [
                    _c("div", { staticClass: "d-flex flex-column" }, [
                      _c(
                        "span",
                        {
                          staticClass:
                            "mission-description mr-4 font-weight-bold"
                        },
                        [_vm._v(_vm._s(mission.description))]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "mission-progress" }, [
                        _vm._v(
                          _vm._s(
                            mission.isAchieved
                              ? "Completed"
                              : mission.currentTaskCount +
                                  "/" +
                                  mission.requiredTaskCount +
                                  " Completed"
                          )
                        )
                      ])
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "action-btn vs-btn",
                    style: mission.isClaimed && { backgroundColor: "#a9a9a9" },
                    attrs: {
                      type: "button",
                      disabled: mission.isClaimed || !mission.isAchieved
                    },
                    on: {
                      click: function($event) {
                        return _vm.claimMission(mission.id)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(
                          mission.isAchieved
                            ? mission.isClaimed
                              ? "Claimed"
                              : "Claim"
                            : "In Progress"
                        ) +
                        "\n    "
                    )
                  ]
                )
              ]
            )
          })
        ],
        2
      )
    : _c("div", { staticClass: "p-6 text-center" }, [
        _vm._v("\n  Loading...\n")
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }